'use strict';

let serviceErrorCodes = Object.freeze({
    NOT_FOUND          : 'ylandsApiService.notFound',
    PERMISSION_DENIED  : 'ylandsApiService.permissionDenied',
    PROFILE_NOT_FOUND  : 'ylandsApiService.profileNotFound',
    INVALID_ASSET      : 'ylandsApiService.invalidAsset',
    INVALID_DATA       : 'ylandsApiService.invalidData',
    ASSET_NOT_FOUND    : 'ylandsApiService.assetNotFound',
    GAME_ITEM_EXISTS   : 'ylandsApiService.gameItemExists',
    GAME_ITEM_NOT_FOUND: 'ylandsApiService.gameItemNotFound',
    ASSET_EXISTS       : 'ylandsApiService.assetExists',
    PROFILE_EXISTS     : 'ylandsApiService.profileExists',
    ALREADY_RATED      : 'ylandsApiService.alreadyRated',
    NOT_PUBLISHED      : 'ylandsApiService.notPublished',
    WRONG_TYPE         : 'ylandsApiService.wrongType',
    RESOURCE_EXISTS    : 'ylandsApiService.resourceExists',
    RESOURCE_NOT_FOUND : 'ylandsApiService.resourceNotFound',
    WRONG_GUID         : 'ylandsApiService.wrongGuid',
    WRONG_IMAGE_TYPE   : 'ylandsApiService.wrongImageType',
    ASSET_BLOCKED      : 'ylandsApiService.assetBlocked',
    ASSET_NOT_OWNED    : 'ylandsApiService.assetNotOwned',
    ASSET_IS_PROTECTED : 'ylandsApiService.assetIsProtected',
    UNABLE_TO_VERIFY_CREATION_AGAINST_GAME_API : 'ylandsApiService.gameApiUnableToVerifyCreation',
    ASSET_WITH_SAME_VERSION_ALREADY_EXISTS: 'ylandsApiService.assetWithSameVersionAlreadyExists',
    ASSET_WITH_SAME_GUID_ALREADY_EXISTS: 'ylandsApiService.assetWithSameGuidAlreadyExists',
    ASSET_WITH_SAME_NAME_ALREADY_EXISTS: 'ylandsApiService.assetWithSameNameAlreadyExists'
});

module.exports = serviceErrorCodes;